/* Temporary solution, until everything gets renamed on backend too */
export function minimalToMinimum(str: string): string {
  if (str.toLowerCase() === 'minimal') {
    return 'Minimum';
  }
  return str;
}
